import { clickoutside } from 'zk-ui';
import Vue from 'vue';

Vue.directive('clickoutside', clickoutside);
